import { useQuery } from "react-query";
import { getType2CompanyOverviewDetails } from "../api/t2Company";

export function useType2CompanyOverviewDetails(cin: string, token?: string) {
  return useQuery({
    queryKey: ["getType2CompanyOverviewDetails", cin, token],
    queryFn: getType2CompanyOverviewDetails,
  });
}
